import { Typography } from "@mui/material";

export default function Typographys({
    gutterBottom,
    noWrap,
    children,
    bold,
    light,
    medium,
    variant,
    sx,
    ...props
}) {
    return (
        <Typography
            variant={variant}
            gutterBottom={gutterBottom}
            noWrap={noWrap}
            sx={sx}
            {...props}
        >
            {children}
        </Typography>
    )
}